<template>
  <div class="wrapper">
    <div class="searchconditions">
      <el-form :model="listForm" ref="listForm" inline>
        <el-form-item label="工厂名称">
          <el-select v-model="listForm.companyId">
            <el-option label="全部" value=""> </el-option>
            <el-option
              v-for="(item, index) of companyList"
              :key="index"
              :label="item.companyName"
              :value="item.companyId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单/出库编号">
          <el-input
            v-model="listForm.orderNum"
            placeholder="请输入订单/出库编号"
            maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item label="接收企业">
          <el-autocomplete
            :popper-append-to-body="false"
            v-model="receiveCompanyName"
            :fetch-suggestions="querySearch"
            placeholder="请输入物料名称"
            @select="(item) => handleSelect(item)"
          >
            <template slot-scope="{ item }">
              <div class="name">{{ item.companyName }}</div>
            </template>
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="出库日期">
          <el-date-picker
            v-model="searchDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="cyan" @click="searchList"
            >查询</el-button
          >
          <el-button icon="el-icon-refresh" type="warning" @click="reset"
            >重置</el-button
          >
          <el-button
            icon="el-icon-download"
            type="primary"
            @click="exportDialog"
            >导出</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="list" v-loading="loading" border>
      <el-table-column
        type="index"
        label="序号"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="sendCompanyName"
        label="发货企业（工厂）"
        min-width="150"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="orderNum"
        label="订单/出库编号"
        min-width="120"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="actionDate"
        label="出库日期"
        min-width="120"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.actionDate | dateformat }}
        </template>
      </el-table-column>
      <el-table-column
        prop="receiveCompanyName"
        label="接收企业"
        min-width="120"
        align="center"
      >
        <!-- <template slot-scope="scope">
          <span v-if="scope.row.receiveCompanyName">{{
            scope.row.receiveCompanyName
          }}</span>
          <span v-else @click="addCompany(scope.row)">添加</span>
        </template> -->
      </el-table-column>
      <el-table-column
        prop="totalWeight"
        label="出库重量（吨）"
        min-width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="outNum"
        label="袋数"
        min-width="100"
        align="center"
      ></el-table-column>
      <el-table-column label="操作" align="center" min-width="100">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="operationBtn(scope.row)"
            >详细信息</el-button
          >
          <el-button
            type="primary"
            size="mini"
            @click="updateDealear(scope.row)"
            >修改</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next, total"
      :page-size="listForm.pageSize"
      :total="total"
      :current-page="listForm.pageNum"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    >
    </el-pagination>
    <el-dialog
      title="详细信息"
      :visible.sync="dialogInfo"
      :close-on-click-modal="false"
      @close="handleDetailClose"
    >
      <el-form
        :model="productInfo"
        ref="productInfo"
        label-width="120px"
        v-if="productInfo"
        class="tracecode-Info"
      >
        <h3 style="margin-bottom: 20px; color: #4da4ca">
          {{ detail.sendCompanyName }}
        </h3>
        <h3 class="info-title">出库信息</h3>
        <el-row>
          <el-col :span="12">
            <el-form-item label="订单/出库编号：">
              <span>{{ detail.orderNum }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出库单名称：">
              <span>{{ detail.orderName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="出库日期：">
              <span> {{ detail.actionDate | dateformat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出库总数量：">
              <span>{{ detail.codeNumber }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="出库总重量：">
              <span>{{ detail.totalWeight }} 吨</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出库企业：">
              <span> {{ detail.sendCompanyName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="出库经手人：">
              <span>{{ detail.actor }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="接收企业：">
              <span> {{ detail.receiveCompanyName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <div
          v-for="(item, index) in detail.productExportLibraryRecordList"
          :key="index"
          class="product-box"
        >
          <h3 style="text-indent: 20px; color: #333333">
            {{ item.productName }}
          </h3>
          <el-row>
            <el-col :span="12">
              <el-form-item label="物料编码：">
                <span v-if="item.productionProduct">{{
                  item.productionProduct.productCode
                }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="物料名称：">
                <span>{{ item.productName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="物料类型：">
                <span v-if="item.productionProduct">{{
                  item.productionProduct.productTypeName
                }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="物料规格：">
                <span v-if="item.productionProduct">{{
                  item.productionProduct.specifications
                }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="出库数量：">
                <span>{{ item.codeNumber }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="出库重量：">
                <span>{{ item.weight }} 吨</span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="dialogInfo = false">关 闭</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改" :visible.sync="dialogDealer" width="40%">
      <el-select
        v-model="dealerForm.receiveCompanyId"
        filterable
        remote
        reserve-keyword
        placeholder="请输入经销商名称"
        :remote-method="dealerChange"
        :loading="loading"
        style="width: 80%"
      >
        <el-option
          v-for="item in dealerList"
          :key="item.companyId"
          :label="item.companyName"
          :value="item.companyId"
        >
        </el-option>
      </el-select>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogDealer = false">取 消</el-button>
        <el-button type="primary" @click="saveDealer">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 导出 -->
    <el-dialog title="导出" :visible.sync="exportTimeDialog" width="40%">
      <el-form inline>
        <el-form-item label="导出范围">
          <el-date-picker
            v-model="exportTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            icon="el-icon-download"
            type="primary"
            size="medium"
            @click="exportOutboundReportXml"
            >导出</el-button
          >
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="exportTimeDialog = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  outWarehouseList,
  getFlowsCompanyInfos,
  getDealerOnlineList,
  comanyPageList,
  updateDealer,
  exportOutboundReport,
} from "@/common/api.js";
import axios from "axios";
import { Message } from "element-ui";
export default {
  data() {
    return {
      listForm: {
        pageNum: 1,
        pageSize: 10,
        companyId: "",
        receiveCompanyId: "",
        orderNum: "",
        startDate: null,
        endDate: null,
        isAll: "1",
      },
      searchDate: null,
      list: [],
      productName: "",
      productList: [],
      companyList: [],
      receiveCompanyName: "",
      receiveCompanyNameList: [],
      loading: false,
      total: 0,
      dialogInfo: false,
      productInfo: {},
      detail: {
        sendCompanyName: "",
        orderName: "",
        orderNum: "",
        actionDate: "",
        codeNumber: 0,
        totalWeight: 0,
        createDate: "",
        actor: "",
        receiveCompanyName: "",
        productExportLibraryRecordList: [],
      },
      dialogDealer: false,
      loadingDealer: false,
      dealerList: [],
      dealerForm: {
        id: "",
        receiveCompanyId: "",
      },
      exportTime: null,
      exportTimeDialog: false,
    };
  },
  mounted() {
    this.getPageList();
    this.getCompanyList();
    this.getReceiveCompnayList();
  },
  methods: {
    exportDialog() {
      this.exportTimeDialog = true;
    },
    // 导出
    exportOutboundReportXml() {
      let startStr = "";
      let endStr = "";
      if (this.exportTime && this.exportTime.length === 2) {
        startStr = this.formDate(this.exportTime[0]);
        endStr = this.formDate(this.exportTime[1]);
      }
      const params = {
        startDate: startStr,
        endDate: endStr,
      };
      Message({
        message: "开始下载，请稍后",
        type: "success",
      });
      exportOutboundReport(params)
        .then((res) => {
          const blob = new Blob([res]);
          console.log(res);
          const fileName = `出库管理_${params.startDate || ""}_${
            params.endDate || ""
          }.xls`;
          const elink = document.createElement("a"); // 创建a标签
          elink.download = fileName; // 为a标签添加download属性
          // a.download = fileName; //命名下载名称
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click(); // 点击下载
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink); // 释放标签
          this.loadingExt = false;
          axios.defaults.responseType = "json";
        })
        .catch((res) => {
          axios.defaults.responseType = "json";
          Message.error("导出请求失败，请稍后重试");
        });
    },
    getPageList() {
      var params = this.listForm;
      this.loading = true;
      outWarehouseList(params).then((res) => {
        this.loading = false;
        if (res.errorCode == 200) {
          this.list = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //工厂列表
    getCompanyList() {
      getFlowsCompanyInfos().then((res) => {
        this.companyList = res;
      });
    },
    // 接收企业列表
    getReceiveCompnayList() {
      let params = {
        companyName: "",
      };
      getDealerOnlineList(params).then((res) => {
        this.receiveCompanyNameList = res.data;
      });
    },
    querySearch(queryString, cb) {
      var restaurants = this.receiveCompanyNameList;
      if (queryString == "" || queryString == undefined) {
        var results = queryString
          ? restaurants.filter(this.createFilter(queryString))
          : restaurants;
        cb(results);
      } else {
        let params = {
          companyName: queryString || "",
        };
        getDealerOnlineList(params).then((res) => {
          cb(res.data);
        });
      }
      // 调用 callback 返回建议列表的数据
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.productName
            .toLowerCase()
            .indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    handleSelect(item) {
      console.log(item);
      this.receiveCompanyName = item.companyName;
      this.listForm.receiveCompanyId = item.companyId;
    },
    //   查询
    searchList() {
      if (this.searchDate) {
        this.listForm.startDate = this.formDate(this.searchDate[0]);
        this.listForm.endDate = this.formDate(this.searchDate[1]);
      } else {
        this.listForm.startDate = "";
        this.listForm.endDate = "";
      }
      this.listForm.pageNum = 1;
      this.getPageList();
    },
    formDate(fromdate) {
      if (fromdate != null) {
        var date = new Date(fromdate);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        var d = date.getDate();
        d = d < 10 ? "0" + d : d;
        return y + "-" + m + "-" + d;
      }
    },
    reset() {
      this.listForm = {
        pageNum: 1,
        pageSize: 10,
        companyId: "",
        receiveCompanyId: "",
        orderNum: "",
        startDate: null,
        endDate: null,
        isAll: "1",
      };
      this.searchDate = null;
      (this.receiveCompanyName = ""), this.getPageList();
    },
    // 详情
    operationBtn(row) {
      this.dialogInfo = true;
      this.$nextTick(() => {
        this.detail = {
          sendCompanyName: row.sendCompanyName,
          orderName: row.orderName,
          actionDate: row.actionDate,
          orderNum: row.orderNum,
          codeNumber: row.codeNumber || 0,
          totalWeight: row.totalWeight || 0,
          createDate: row.createDate,
          receiveCompanyName: row.receiveCompanyName,
          actor: row.actor,
          productExportLibraryRecordList: row.productExportLibraryRecordList,
        };
      });
    },

    handleCurrentChange(cpage) {
      this.listForm.pageNum = cpage;
      this.getPageList();
    },
    handleSizeChange(psize) {
      this.listForm.pageSize = psize;
      this.getPageList();
    },
    //关闭详情
    handleDetailClose() {
      this.detail = {
        sendCompanyName: "",
        orderName: "",
        orderNum: "",
        actionDate: "",
        codeNumber: 0,
        totalWeight: 0,
        createDate: "",
        actor: "",
        receiveCompanyName: "",
        productExportLibraryRecordList: [],
      };
    },
    updateDealear(row) {
      this.dialogDealer = true;
      this.dealerForm.id = row.id;
      this.dealerForm.receiveCompanyId = "";
      this.dealerList = [];
    },
    dealerChange(query) {
      if (query) {
        this.loadingDealer = true;
        let params = {
          pageNum: 1,
          pageSize: 100,
          companyType: 8,
          companyName: query,
        };
        setTimeout(() => {
          comanyPageList(params).then((res) => {
            this.loadingDealer = false;
            this.dealerList = res.data.list;
          });
        }, 200);
      } else {
        this.options = [];
      }
    },
    saveDealer() {
      if (!this.dealerForm.receiveCompanyId) {
        this.$message.error("请选择经销商");
        return;
      }
      updateDealer(this.dealerForm).then((res) => {
        if (res.errorCode == "200") {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.dialogDealer = false;
          this.getPageList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  h3 {
    margin-bottom: 20px;
  }
  .searchconditions {
    width: calc(100% - 30px);
    background: #fff;
    border-radius: 6px;
    margin-top: 10px;
    padding: 20px 15px;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
    .el-form {
      .el-form-item {
        display: inline-block;
        // margin-right: 10px;
        vertical-align: top;
        margin: 5px 15px 5px 0px;
        /deep/.el-button {
          padding: 8px 15px;
          font-size: 12px;
          border-radius: 3px;
        }
      }
    }
  }
  .product-box {
    margin-top: 20px;
    box-shadow: #d0d0d0 0px 0px 10px;
    border-radius: 5px;
    padding: 10px 0;
  }
  .el-row {
    margin: 10px 0 0 !important ;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    background-color: #ffffff;
    padding: 5px 15px 0;
    .add-btn {
      float: left;
      padding: 0;
      margin-top: 5px;
      margin-bottom: 10px;
      .el-button {
        padding: 8px 15px;
        font-size: 12px;
        border-radius: 3px;
      }
    }
  }
  .tracecode-Info {
    /deep/.el-form-item {
      margin-bottom: 0 !important;
    }
    /deep/.el-row {
      margin: 0 !important;
    }
  }
  .info-title {
    border-left: 3px solid #4da4ca;
    color: #4da4ca;
    text-indent: 15px;
    margin-top: 15px;
  }
  /deep/ .el-autocomplete-suggestion {
    min-width: 100%;
    width: auto !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/system/stockCenter/outWarehouse.vue